/*
 * @Author: lixin jiang
 * @Date: 2021-07-08 09:18:12
 * @LastEditTime: 2021-07-15 13:27:13
 * @LastEditors: lixin jiang
 * @Description:
 * @FilePath: /@aidesign/aid-base/src/utils/buttonContext.js
 * @
 */

import * as React from 'react';

const ArcButtonGroupContext = React.createContext({ onChange: () => {} });

export const ArcButtonGroupContextProvider = ArcButtonGroupContext.Provider;

export default ArcButtonGroupContext;
